// extracted by mini-css-extract-plugin
module.exports = {"upgradeIconContainer":"FeatureProtector_upgradeIconContainer__3UgGo","blocked":"FeatureProtector_blocked__2VIEm"};